import { render, staticRenderFns } from "./ybUpload.vue?vue&type=template&id=96ed06a6&"
import script from "./ybUpload.vue?vue&type=script&lang=js&"
export * from "./ybUpload.vue?vue&type=script&lang=js&"
import style0 from "./ybUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports